var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusic = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.548,
    height: 42.797,
    viewBox: "0 0 32.548 42.797",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5552",
    "data-name": "Caminho 5552",
    d: "M214.528,113.553a22.182,22.182,0,0,1-.13,3.211,6.463,6.463,0,0,1-7.063,5.541,4.863,4.863,0,0,1-4.434-3.22,4.986,4.986,0,0,1,2.191-6.283,14.318,14.318,0,0,1,4.4-1.338c2.065-.42,2.286-.664,2.284-2.8q-.007-6.247-.034-12.494c0-.125,0-.251-.008-.375-.058-.9-.361-1.139-1.237-.96-3.1.637-13.024,2.661-14.881,3.032-1.164.233-1.373.478-1.377,1.695-.024,6.489-.034,12.977-.075,19.466a11.344,11.344,0,0,1-.266,2.389,6.571,6.571,0,0,1-5.922,5.317,5.064,5.064,0,0,1-4.568-1.319,5.32,5.32,0,0,1,.96-8.04,14.07,14.07,0,0,1,4.457-1.513c.415-.091.827-.2,1.232-.323a1.807,1.807,0,0,0,1.388-1.861c.013-1,.025-2,.026-3q.008-9.894.012-19.787c0-1.8.5-2.437,2.247-2.816q8.825-1.918,17.652-3.827a10.439,10.439,0,0,1,1.574-.228,1.311,1.311,0,0,1,1.439,1.083,6.656,6.656,0,0,1,.141,1.434c.01,4.861,0,22.879-.011,27.025Z",
    transform: "translate(-181.995 -84.008)",
    fill: "#f95e14",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/music.4688845b124d3f58.svg";